import {APIError} from 'data/errors';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	SearchProcedure,
	SearchProcedureParams,
	SearchProcedureResponse,
} from 'domain/usecases/private/guide-flow/medical-guide/search-procedure';

export class RemoteSearchProcedure implements SearchProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<SearchProcedureResponse>,
	) {}

	async get({signal, ...params}: SearchProcedureParams): Promise<SearchProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
